export const EPF_FILING_DETAILS_URL = 'unifier/getEpfFilingDetails';
export const MSME_PAYMENT_DELAYS_URL = 'unifier/getMsmePaymentDelays';

/** ServiceDefinition ids — the keys polus BEFE puts under `responseBody`. */
export const BEFE_SERVICE_IDS = {
    EPF_FILING_DETAILS: 'UW_EPF_FILING_DETAILS',
    MSME_PAYMENT_DELAYS: 'UW_MSME_PAYMENT_DELAYS',
} as const;

/** BEFE answers responseCode 20 even when UW failed; only the UW envelope's statusCode tells. */
export const UW_SUCCESS_STATUS_CODE = 200;

/** Months of EPF history the card covers — polus `requiredMonthsForEpfData`. */
export const EPF_WINDOW_MONTHS = 24;

export const MSME_PLOT_LEGENDS = {
    PERIODS: 'periods',
    SUPPLIERS: 'suppliers',
} as const;

export const MSME_DELAY_TITLE = 'MSME Delay';
export const MSME_DELAY_INFO_TEXT =
    'Amounts owed to MSME suppliers beyond the 45-day limit, as reported half-yearly to MCA. Grey = no delay reported for that half-year.';
export const MSME_DELAY_LEGEND = { yValue: 'Delay', yValue2: 'No Delay', yValue3: 'Unavailable' };
export const MSME_DELAY_SECONDARY_PREFIX = ' MSME Delay from ';

/** How long the MSME card waits for an unfetched EPF card to settle before fetching anyway. */
export const EPF_SETTLE_TIMEOUT_MS = 10000;

export const MSME_DELAY_CARD_HEADER = { title: MSME_DELAY_TITLE, infoText: MSME_DELAY_INFO_TEXT };

export const MSME_DELAYS_TILE_TITLE = 'MSME Delays';
export const MSME_DELAYS_TILE_DURATION_PREFIX = 'as of ';
